import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})
export class AssetRequestService {
  private assetUrl = environment.assetUrl;

  constructor(private http: HttpClient) {}

  getFormTemplateById(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-request-form-templates/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  // Get all form templates for dropdown
  getFormTemplates(): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-request-form-templates/`;
    return this.http.get<any>(url, { withCredentials: true });
  }
  
  getAssetRequests(filters?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-requests/`;
    let params = new HttpParams();
    
    if (filters) {
      if (filters.limit) params = params.set('limit', filters.limit.toString());
      if (filters.offset !== undefined) params = params.set('offset', filters.offset.toString());
      if (filters.request_date) params = params.set('request_date', filters.request_date);
      if (filters.request_type) params = params.set('request_type', filters.request_type);
      if (filters.subsidiary_id) params = params.set('subsidiary_id', filters.subsidiary_id);
      if (filters.location_id) params = params.set('location_id', filters.location_id);
      if (filters.requester_id) params = params.set('requester_id', filters.requester_id);
      if (filters.request_id) params = params.set('request_id', filters.request_id);
      if (filters.get_references) params = params.set('get_references', filters.get_references);
    }
    
    return this.http.get<any>(url, { params, withCredentials: true });
  }

  createAssetRequest(data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-requests/`;
    return this.http.post<any>(url, data, { withCredentials: true });
  }

  updateAssetRequest(id: string, data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-requests/${id}`;
    return this.http.put<any>(url, data, { withCredentials: true });
  }
  
  getAssetRequest(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-requests/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  deleteAssetRequest(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-requests/${id}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }
}

